var config = require('../config.js')
module.exports = {
  couponList: config.host + '/market/api/v1/coupon/list/c', //获取优惠券配置信息
  couponShowList: config.host + '/market/api/v1/coupon/showList/c', //获取演出优惠券
  couponShowList2: config.host + '/market/api/v1/coupon/showListV2/c', //获取演出优惠券
  // couponShowList2: config.host + '/market/api/v1/coupon/showListV4/c', //获取演出优惠券
  couponGetShowList: config.host + '/market/api/v1/coupon/getShowList/c', //获取优惠券使用演出
  couponMyList: config.host + '/market/api/v1/coupon/myList/c', //获取我的优惠券
  couponReceive: config.host + '/market/api/v1/coupon/receive/c', //优惠券领取
  couponManageDetail: config.host + '/market/api/v1/coupon/detail/c', //获取优惠详情
  couponGetReceive: config.host + '/market/api/v1/coupon/getCouponReceive/c', //获取优惠详情
  couponMyListSum: config.host + '/market/api/v1/coupon/myListSum/c', //获取我的优惠券数量

  couponOtherList: config.host + '/market/api/v1/coupon/listByCouponOther/c', //获取优惠券领取页面
  couponOtherReceive: config.host + '/market/api/v1/coupon/receiveOther/c', //优惠券领取

  activityAetActivity: config.host + '/market/api/v1/activity/getActivity/c', //获取活动优惠
  // 查询当前租户是否使用新促销逻辑，data.UseUnifiedPromotion
  promotionEngineMode: config.host + '/market/api/v1/promotion/engine-mode/c',
  userPointGetPointRule: config.host + '/market/api/v1/userPoint/getPointRule/c', //获取积分通用规则
  getTimeLimitCompute: config.host + '/market/api/v1/timeLimitedDiscount/getTimeLimitCompute/c', //获取限时折扣 老版本 参数不同
  getTimeLimitComputeNew: config.host + '/market/api/v1/timeLimitedDiscount/getLimitBuyAmount/c', //获取限时折扣
  getOrderDiscountAndLimit: config.host + '/market/api/v1/activity/orderDiscountAndLimit/c', //获取套票、会员折扣、限时折扣、满减活动
  getOrderDiscountAndLimit2: config.host + '/market/api/v1/activity/confirmOrderInfo/c', //获取套票、会员折扣、限时折扣、满减活动
  // 确认下单信息V2：SelectionMode/SelectedGiftCardIds/ExplicitVipDiscountSelected/SelectedPoint/previousQuote
  getOrderDiscountAndLimit3: config.host + '/market/api/v1/activity/confirmOrderInfo/v2/c',
  bindCoupon: config.host + '/market/api/v1/couponManage/bindCoupon/c', //优惠券券码兑换
  getCouponVerifyCode: config.host + '/market/api/v1/couponManage/verifyCode/c', //优惠券券码兑换验证码

}
